import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  AdvisorApiCredentialService,
  type Wealthlane_Dtos_AdvisorApi_AdvisorApiCredentialWithSecretDto,
  type Wealthlane_Dtos_AdvisorApi_CreateAdvisorApiCredentialDto,
} from '@wealthlane/api-services/wealthlane-identity-service';

const usePostAdvisorApiCredential = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
): UseMutationResult<
  Wealthlane_Dtos_AdvisorApi_AdvisorApiCredentialWithSecretDto | undefined,
  unknown,
  Wealthlane_Dtos_AdvisorApi_CreateAdvisorApiCredentialDto,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload) => {
      return await handleRequest(
        AdvisorApiCredentialService.postApiIdentityApiAppAdvisorApiCredential(payload),
      );
    },
    {
      onSuccess: (data) => {
        if (data != null) {
          void queryClient.invalidateQueries('getAdvisorApiCredentialList');
          toast.success(
            <ToastComponent label='Success' message='Advisor API key generated successfully.' />,
          );
        }
      },
    },
  );
};

export default usePostAdvisorApiCredential;
